import { type VariantProps, cva } from 'class-variance-authority';

export const modalContentStyles = cva(['relative', 'bg-white'], {
  variants: {
    variant: {
      default: [
        'rounded-3xl',
        'max-h-[90dvh]',
        'overflow-y-auto',
        'overscroll-contain',
        'max-md:w-[calc(100vw-2rem)]',
        'max-md:rounded-[14px]',
        'max-md:[&>*:not(header)]:w-full',
        'max-md:[&>*:not(header)]:min-w-0',
        'max-md:[&>*:not(header)]:max-w-full',
      ],
      old: [],
      insetMobile: ['rounded-3xl', 'max-md:w-[calc(100vw-2rem)]'],
      fullScreenMobile: ['rounded-3xl', 'max-md:w-screen', 'max-md:h-dvh', 'max-md:rounded-none'],
      bottomSheet: ['rounded-3xl', 'max-h-dvh', 'max-md:shadow-card', 'max-md:w-screen', 'max-md:rounded-b-none'],
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ModalContentVariantsProps = VariantProps<typeof modalContentStyles>;

export const modalActionButtonStyles = cva([
  'max-md:h-auto',
  'max-md:min-h-10.5',
  'max-md:min-w-0',
  'max-md:flex-1',
  'max-md:whitespace-normal',
  'max-md:px-2',
  'max-md:text-sm',
]);
